import { default as api } from 'config/frontApiConf';

export const getContentService = async (pageType = 1) => {
	try {
		let result = await api.get(`/get-page-content/${pageType}`);
		return result;
	} catch (error) {
		return error;
	}
};

export const getHomeContentService = async () => {
	try {
		let result = await api.get(`/get-home-page-content`);
		return result;
	} catch (error) {
		return error;
	}
};
